import script from "./Chapter9.vue?vue&type=script&setup=true&lang=js"
export * from "./Chapter9.vue?vue&type=script&setup=true&lang=js"

import "./Chapter9.vue?vue&type=style&index=0&id=7fced411&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fced411"]])

export default __exports__